import { Controller } from "@hotwired/stimulus";

interface AnalyticsProperties {
  [key: string]: unknown;
}

export default class extends Controller {
  declare readonly nameValue: string;
  declare readonly propertiesValue: Record<string, unknown>;

  static values = {
    name: String,
    properties: Object,
  };

  trackEvent(
    eventName: string = this.nameValue,
    properties: AnalyticsProperties = {}
  ): void {
    if (!window.analytics) return;

    const globalProperties = window.analyticsProperties || {};
    const mergedProperties = {
      ...globalProperties,
      ...this.propertiesValue,
      ...properties,
    };

    window.analytics.track(eventName, mergedProperties);
  }
}
